// extracted by mini-css-extract-plugin
export default {"fill":"Icon_fill__4y6Ac"};